import styled from 'styled-components';
import { colours, common } from 'themes/default';
import { Row } from 'components/shared/Layout';

export const InputContainer = styled('div')`
  background: ${common.notifications.information.backgroundColour};
  display: flex;
  padding: 16px 16px;
  margin-bottom: 24px;

  input {
    margin: 8px 8px 8px 0;
  }

  > div {
    margin-right: 32px;
  }
`;

export const Error = styled.div`
  color: red;

  & a {
    color: red;
  }
`;

export const StyledP = styled('p')`
  margin: 0;
`;

export const StyledPriceTable = styled(Row)`
  padding: 16px;
  box-shadow: 0px 0px 30px ${colours.Greyscale.MistGrey};
`;

export const StyledTableRow = styled(Row)`
  &:last-child {
    border-top: solid 1px #333;
    border-bottom: solid 1px #333;
  }
`;

export const StyledLabel = styled.label`
  display: block;
  margin-top: 16px;
`;

export const Spacer = styled.div`
  padding-top: 15px;
  padding-bottom: 15px;
`;

export const FormattedPoints = styled('span')`
  text-transform: lowercase;
`;
